import { DB_PREFIX_REFERENCES, DB_PREFIX_REFEREES } from './constants';

export default {
  [DB_PREFIX_REFEREES]: [],
  [DB_PREFIX_REFERENCES]: [],
};
